const API_BASE = process.env.REACT_APP_API_URL || 'https://voidlink.shop/api';

const getToken = () => localStorage.getItem('voidlink_token');

export const getTariffs = async () => {
  const response = await fetch(`${API_BASE}/vpn/tariffs`);
  if (!response.ok) throw new Error('Failed to fetch tariffs');
  return response.json();
};

export const createPayment = async (tariffKey, promoCode = null) => {
  const token = getToken();
  const response = await fetch(`${API_BASE}/vpn/payment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ tariffKey, promoCode }),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to create payment');
  }
  return response.json();
};

export const getSubscription = async () => {
  const token = getToken();
  const response = await fetch(`${API_BASE}/vpn/subscription`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error('Failed to fetch subscription');
  return response.json();
};
